var _a, _b;
import { Unit } from "utility/number";
export var SelectionTubeType;
(function (SelectionTubeType) {
    SelectionTubeType["EDGE_VACUUM"] = "edge~vacuum";
    SelectionTubeType["EDGE_COMPRESSED_AIR"] = "edge~compressed_air";
    SelectionTubeType["EDGE_UNKNOWN"] = "edge~unknown";
    SelectionTubeType["TUBE_CONNECTION_VACUUM"] = "tube_connection~vacuum";
    SelectionTubeType["TUBE_CONNECTION_COMPRESSED_AIR"] = "tube_connection~compressed_air";
    SelectionTubeType["TUBE_CONNECTION_UNKNOWN"] = "tube_connection~unknown";
})(SelectionTubeType || (SelectionTubeType = {}));
export var TubeConnectionSelectionTypes = [
    SelectionTubeType.TUBE_CONNECTION_COMPRESSED_AIR,
    SelectionTubeType.TUBE_CONNECTION_VACUUM,
    SelectionTubeType.TUBE_CONNECTION_UNKNOWN,
];
export var SelectionDecentralizedPumpType = "decentralized_pump";
export var MenuItem;
(function (MenuItem) {
    MenuItem["SELECTED_ENTITY"] = "selected_entity";
    MenuItem["APPLICATION_SPEED"] = "application_speed";
})(MenuItem || (MenuItem = {}));
export var OverlayData;
(function (OverlayData) {
    OverlayData["PERFORMANCE_DATA"] = "performance_data";
    OverlayData["VACUUM_LEVEL_PS"] = "vacuum_level_ps";
    OverlayData["VACUUM_LEVEL_ES"] = "vacuum_level_es";
})(OverlayData || (OverlayData = {}));
export var UnitSystem;
(function (UnitSystem) {
    UnitSystem["METRIC"] = "metric";
    UnitSystem["IMPERIAL"] = "imperial";
})(UnitSystem || (UnitSystem = {}));
export var tubeDiameterOptionInitialIndex = (_a = {},
    _a[UnitSystem.METRIC] = {
        centralized: 21,
        decentralized: 21,
    },
    _a[UnitSystem.IMPERIAL] = {
        centralized: 15,
        decentralized: 17,
    },
    _a);
export var tubeDiameterOptions = (_b = {},
    _b[UnitSystem.METRIC] = [
        {
            outerLabel: "59.8",
            innerLabel: "50",
            value: 0.05,
            outerValue: 0.0598,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "54",
            innerLabel: "45",
            value: 0.045,
            outerValue: 0.054,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "46",
            innerLabel: "38",
            value: 0.038,
            outerValue: 0.046,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "40",
            innerLabel: "32",
            value: 0.032,
            outerValue: 0.04,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "32.4",
            innerLabel: "25",
            value: 0.025,
            outerValue: 0.0324,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "25",
            innerLabel: "19",
            value: 0.019,
            outerValue: 0.025,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "22.2",
            innerLabel: "16",
            value: 0.016,
            outerValue: 0.0222,
            unit: Unit.MM,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "16",
            innerLabel: "13",
            value: 0.013,
            outerValue: 0.016,
            unit: Unit.MM,
        },
        {
            outerLabel: "16",
            innerLabel: "11",
            value: 0.011,
            outerValue: 0.016,
            unit: Unit.MM,
        },
        {
            outerLabel: "14",
            innerLabel: "12",
            value: 0.012,
            outerValue: 0.014,
            unit: Unit.MM,
        },
        {
            outerLabel: "14",
            innerLabel: "11",
            value: 0.011,
            outerValue: 0.014,
            unit: Unit.MM,
        },
        {
            outerLabel: "14",
            innerLabel: "9.5",
            value: 0.0095,
            outerValue: 0.014,
            unit: Unit.MM,
        },
        {
            outerLabel: "12",
            innerLabel: "10",
            value: 0.01,
            outerValue: 0.012,
            unit: Unit.MM,
        },
        {
            outerLabel: "12",
            innerLabel: "9.5",
            value: 0.0095,
            outerValue: 0.012,
            unit: Unit.MM,
        },
        {
            outerLabel: "12",
            innerLabel: "9",
            value: 0.009,
            outerValue: 0.012,
            unit: Unit.MM,
        },
        {
            outerLabel: "12",
            innerLabel: "8",
            value: 0.008,
            outerValue: 0.012,
            unit: Unit.MM,
        },
        {
            outerLabel: "10",
            innerLabel: "8",
            value: 0.008,
            outerValue: 0.01,
            unit: Unit.MM,
        },
        {
            outerLabel: "10",
            innerLabel: "7.5",
            value: 0.0075,
            outerValue: 0.01,
            unit: Unit.MM,
        },
        {
            outerLabel: "10",
            innerLabel: "7",
            value: 0.007,
            outerValue: 0.01,
            unit: Unit.MM,
        },
        {
            outerLabel: "10",
            innerLabel: "6.5",
            value: 0.0065,
            outerValue: 0.01,
            unit: Unit.MM,
        },
        {
            outerLabel: "8",
            innerLabel: "6",
            value: 0.006,
            outerValue: 0.008,
            unit: Unit.MM,
        },
        {
            outerLabel: "8",
            innerLabel: "5.5",
            value: 0.0055,
            outerValue: 0.008,
            unit: Unit.MM,
        }, // Default Central
        {
            outerLabel: "6",
            innerLabel: "4",
            value: 0.004,
            outerValue: 0.006,
            unit: Unit.MM,
        }, // Default Decentral
        {
            outerLabel: "4",
            innerLabel: "2.7",
            value: 0.0027,
            outerValue: 0.004,
            unit: Unit.MM,
        },
        {
            outerLabel: "4",
            innerLabel: "2.5",
            value: 0.0025,
            outerValue: 0.004,
            unit: Unit.MM,
        },
        {
            outerLabel: "4",
            innerLabel: "2",
            value: 0.002,
            outerValue: 0.004,
            unit: Unit.MM,
        },
    ],
    _b[UnitSystem.IMPERIAL] = [
        {
            outerLabel: "2.4",
            innerLabel: '2"',
            value: 0.0508,
            outerValue: 0.0598,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "2.1",
            innerLabel: '1-3/4"',
            value: 0.0445,
            outerValue: 0.054,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "1.8",
            innerLabel: '1-1/2"',
            value: 0.0381,
            outerValue: 0.046,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "1.6",
            innerLabel: '1-1/4"',
            value: 0.0318,
            outerValue: 0.04,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "1.3",
            innerLabel: '1"',
            value: 0.0254,
            outerValue: 0.0324,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "1.0",
            innerLabel: '3/4"',
            value: 0.0191,
            outerValue: 0.025,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: "0.9",
            innerLabel: '5/8"',
            value: 0.0159,
            outerValue: 0.0222,
            unit: Unit.IN,
            showOnlyForVacuumTubes: true,
        },
        {
            outerLabel: '3/4"',
            innerLabel: "0.566",
            value: 0.0143764,
            outerValue: 0.0191,
            unit: Unit.IN,
        },
        {
            outerLabel: '3/4"',
            innerLabel: "0.500",
            value: 0.0127,
            outerValue: 0.0191,
            unit: Unit.IN,
        },
        {
            outerLabel: '1/2"',
            innerLabel: "0.375",
            value: 0.009525,
            outerValue: 0.0127,
            unit: Unit.IN,
        },
        {
            outerLabel: '1/2"',
            innerLabel: "0.320",
            value: 0.008128,
            outerValue: 0.0127,
            unit: Unit.IN,
        },
        {
            outerLabel: '3/8"',
            innerLabel: "0.275",
            value: 0.006985,
            outerValue: 0.009525,
            unit: Unit.IN,
        },
        {
            outerLabel: '3/8"',
            innerLabel: "0.250",
            value: 0.00635,
            outerValue: 0.009525,
            unit: Unit.IN,
        },
        {
            outerLabel: '5/16"',
            innerLabel: "0.236",
            value: 0.0059944,
            outerValue: 0.007938,
            unit: Unit.IN,
        },
        {
            outerLabel: '5/16"',
            innerLabel: "0.233",
            value: 0.0059182,
            outerValue: 0.007938,
            unit: Unit.IN,
        },
        {
            outerLabel: '5/16"',
            innerLabel: "0.217",
            value: 0.0055118,
            outerValue: 0.007938,
            unit: Unit.IN,
        }, // Default Central
        {
            outerLabel: '1/4"',
            innerLabel: "0.180",
            value: 0.004572,
            outerValue: 0.00635,
            unit: Unit.IN,
        },
        {
            outerLabel: '1/4"',
            innerLabel: "0.170",
            value: 0.004318,
            outerValue: 0.00635,
            unit: Unit.IN,
        }, // Default Decentral
        {
            outerLabel: '1/4"',
            innerLabel: "0.127",
            value: 0.0032258,
            outerValue: 0.00635,
            unit: Unit.IN,
        },
        {
            outerLabel: '1/4"',
            innerLabel: "0.125",
            value: 0.003175,
            outerValue: 0.00635,
            unit: Unit.IN,
        },
        {
            outerLabel: '5/32"',
            innerLabel: "0.106",
            value: 0.0026924,
            outerValue: 0.003969,
            unit: Unit.IN,
        },
        {
            outerLabel: '5/32"',
            innerLabel: "0.094",
            value: 0.0023876,
            outerValue: 0.003969,
            unit: Unit.IN,
        },
    ],
    _b);
export var ChecklistItemName;
(function (ChecklistItemName) {
    ChecklistItemName["ADD_GRIP_POSITION"] = "add_grip_position";
    ChecklistItemName["SELECT_CUP"] = "select_cup";
    ChecklistItemName["ADD_PUMP"] = "add_pump";
    ChecklistItemName["ADD_TUBE_CONNECTION"] = "add_tube_connection";
    ChecklistItemName["CONNECT_PARTS"] = "connect_parts";
    ChecklistItemName["CALCULATE"] = "calculate";
})(ChecklistItemName || (ChecklistItemName = {}));
export var MIXED_VALUES_CONSTANT = "MIXED_VALUES_CONSTANT";
